import { useState } from 'react'
import OneRatio from './../../assets/images/landing-page/one_ratio.png'
import OneRatioMobile from './../../assets/images/landing-page/one_ratio_mobile.png'
import MultipleRatios from './../../assets/images/landing-page/multiple_ratios.png'
import MultipleRatiosMobile from './../../assets/images/landing-page/multiple_ratios_mobile.png'
import WithAI from './../../assets/images/landing-page/with_ai.png'
import WithoutAI from './../../assets/images/landing-page/without_ai.png'
import Netflix from './../../assets/images/landing-page/netflix.png'
import Drawkit from './../../assets/images/landing-page/drawkit.png'
import Figma from './../../assets/images/landing-page/figma.png'
import Stripe from './../../assets/images/landing-page/stripe.png'
import TestimonialLeft from './../../assets/images/landing-page/testimonial_left.png'
import TestimonialRight from './../../assets/images/landing-page/testimonial_right.png'
import PersonOne from './../../assets/images/landing-page/person_1.png'
import PersonTwo from './../../assets/images/landing-page/person_2.png'
import PersonThree from './../../assets/images/landing-page/person_3.png'

const testimonials = [
  {
    author: 'Orsolya Anna Tóth',
    message:
      'Software that is not just a one-trick pony but makes many different aspects of video work easier and smoother.',
  },
  {
    author: 'Angela Kanwar',
    message:
      'It has been convenient and time saving to have such engaging content made for all our social platforms at the same time. We like our members to tell their own stories, so having a voiceover telling the story and background music accompanying it has been a big win for us.',
  },
  {
    author: 'Markus Beeken',
    message:
      'Seeing this go from concept to final version, and exactly the way I wanted it to be, was made all the easier using the Cerebriam Studio online editor. An intuitive, simple platform for video editing.',
  },
 // {
  //  author: 'Tobi Hashima',
   // message:
     // 'Qs far as I know, all the housing made by Lucy Properti has a very strategic location, close to the center of the Government, making it easier for us to carry out activities',
  //},
  //{
   // author: 'Morris Davies',
  //  message:
    //  'Rs far as I know, all the housing made by Lucy Properti has a very strategic location, close to the center of the Government, making it easier for us to carry out activities',
 // },
]

const Services = ({ setIsSignUpOpen }) => {
  const [activeTestimonial, setActiveTestimonial] = useState(2)
  const changeTestimonial = (value) => {
    setActiveTestimonial(value)
  }
  return (
    <section className="cerebriam-services">
      <div className="cerebriam-container">
        <div className="cerebriam-content animate__animated animate__zoomIn">
          <svg
            width="51"
            height="52"
            viewBox="0 0 51 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M34.75 6.00006C35.0815 6.00006 35.3995 5.86837 35.6339 5.63394C35.8683 5.39952 36 5.08158 36 4.75006V2.25006C36 1.91854 35.8683 1.6006 35.6339 1.36618C35.3995 1.13176 35.0815 1.00006 34.75 1.00006C34.4185 1.00006 34.1005 1.13176 33.8661 1.36618C33.6317 1.6006 33.5 1.91854 33.5 2.25006V4.75006C33.5 5.08158 33.6317 5.39952 33.8661 5.63394C34.1005 5.86837 34.4185 6.00006 34.75 6.00006Z"
              fill="green"
            />
            <path
              d="M47.2501 18.5001H49.7501C50.0816 18.5001 50.3996 18.3684 50.634 18.1339C50.8684 17.8995 51.0001 17.5816 51.0001 17.2501C51.0001 16.9185 50.8684 16.6006 50.634 16.3662C50.3996 16.1318 50.0816 16.0001 49.7501 16.0001H47.2501C46.9186 16.0001 46.6007 16.1318 46.3662 16.3662C46.1318 16.6006 46.0001 16.9185 46.0001 17.2501C46.0001 17.5816 46.1318 17.8995 46.3662 18.1339C46.6007 18.3684 46.9186 18.5001 47.2501 18.5001Z"
              fill="green"
            />
            <path
              d="M42.2501 11.0002C42.4141 11.0022 42.5766 10.9699 42.7273 10.9053C42.878 10.8407 43.0135 10.7453 43.1251 10.6252L45.6251 8.12519C45.74 8.01029 45.8312 7.87387 45.8934 7.72374C45.9556 7.57361 45.9876 7.4127 45.9876 7.25019C45.9876 7.08769 45.9556 6.92678 45.8934 6.77665C45.8312 6.62651 45.74 6.4901 45.6251 6.37519C45.5102 6.26029 45.3738 6.16914 45.2237 6.10695C45.0736 6.04476 44.9126 6.01276 44.7501 6.01276C44.5876 6.01276 44.4267 6.04476 44.2766 6.10695C44.1265 6.16914 43.99 6.26029 43.8751 6.37519L41.3751 8.87519C41.2556 8.98742 41.1603 9.12296 41.0951 9.27346C41.0299 9.42395 40.9963 9.5862 40.9963 9.75019C40.9963 9.91419 41.0299 10.0764 41.0951 10.2269C41.1603 10.3774 41.2556 10.513 41.3751 10.6252C41.4867 10.7453 41.6223 10.8407 41.773 10.9053C41.9236 10.9699 42.0862 11.0022 42.2501 11.0002Z"
              fill="green"
            />
            <path
              d="M38.3499 13.6502C34.3428 9.49601 29.743 5.95768 24.6999 3.15023C19.9749 0.650228 16.4999 0.325229 14.6999 2.17523C14.2942 2.59997 13.9787 3.10248 13.7725 3.65245C13.5663 4.20241 13.4735 4.78845 13.4999 5.37523V21.6502C13.4702 23.2802 12.8171 24.8369 11.6749 26.0002L3.97492 33.7752C3.03007 34.7057 2.27973 35.8148 1.76756 37.0381C1.2554 38.2613 0.991638 39.5741 0.991638 40.9002C0.991638 42.2263 1.2554 43.5392 1.76756 44.7624C2.27973 45.9856 3.03007 47.0947 3.97492 48.0252C4.90541 48.9701 6.01453 49.7204 7.23774 50.2326C8.46095 50.7448 9.77381 51.0085 11.0999 51.0085C12.426 51.0085 13.7389 50.7448 14.9621 50.2326C16.1853 49.7204 17.2944 48.9701 18.2249 48.0252L18.4999 47.7752L19.8249 49.0752C20.4276 49.6895 21.1476 50.1764 21.9421 50.5071C22.7366 50.8377 23.5894 51.0055 24.4499 51.0002C26.1851 50.9936 27.8473 50.3014 29.0742 49.0745C30.3011 47.8476 30.9933 46.1854 30.9999 44.4502C31.0051 43.5897 30.8374 42.7369 30.5068 41.9424C30.1761 41.1479 29.6892 40.4279 29.0749 39.8252L28.1749 38.9002C28.8715 38.6427 29.6073 38.5074 30.3499 38.5002H47.2499C47.4315 38.4943 47.6101 38.4518 47.7749 38.3752C48.5531 38.2539 49.2718 37.8859 49.8249 37.3252C51.6749 35.5002 51.3249 32.0252 48.8499 27.3252C46.0445 22.2733 42.5061 17.665 38.3499 13.6502ZM16.4249 3.92523C16.8399 3.6107 17.3558 3.45947 17.8749 3.50023C19.8639 3.6922 21.7853 4.32412 23.4999 5.35023C28.3044 8.04442 32.6989 11.4118 36.5499 15.3502C40.4883 19.2013 43.8557 23.5958 46.5499 28.4002C48.6999 32.5252 48.6499 34.8252 47.9749 35.5252C47.7737 35.689 47.5417 35.8109 47.2928 35.8839C47.0438 35.9569 46.7827 35.9794 46.5249 35.9502C43.1032 35.4149 39.8756 34.012 37.1499 31.8752C36.1749 31.2002 35.2499 30.5002 34.3499 29.8002C34.6007 28.99 34.7354 28.1483 34.7499 27.3002C34.7621 25.7478 34.4127 24.2138 33.7293 22.8198C33.0458 21.4257 32.0472 20.21 30.8125 19.2688C29.5778 18.3276 28.141 17.6869 26.6157 17.3972C25.0904 17.1076 23.5187 17.1771 22.0249 17.6002C21.3499 16.7002 20.6499 15.7752 19.9749 14.8002C17.8662 12.0499 16.4976 8.80499 15.9999 5.37523C15.9707 5.11742 15.9933 4.85637 16.0663 4.60739C16.1392 4.35841 16.2612 4.12649 16.4249 3.92523ZM32.2749 28.0752C30.7749 26.8252 29.3249 25.5752 27.8999 24.1002C26.4749 22.6252 25.1749 21.2252 23.9249 19.7252C24.9846 19.5935 26.0602 19.6896 27.0798 20.007C28.0994 20.3245 29.0394 20.856 29.837 21.566C30.6346 22.2761 31.2714 23.1482 31.7047 24.1242C32.1381 25.1002 32.3581 26.1574 32.3499 27.2252C32.3499 27.5502 32.2999 27.8002 32.2749 28.0752ZM5.72492 46.2752C5.00675 45.5764 4.43591 44.7406 4.04614 43.8175C3.65636 42.8943 3.45554 41.9023 3.45554 40.9002C3.45554 39.8981 3.65636 38.9062 4.04614 37.983C4.43591 37.0598 5.00675 36.2241 5.72492 35.5252L6.14992 35.1002C6.51086 37.8246 7.75955 40.3541 9.7028 42.2973C11.6461 44.2406 14.1755 45.4893 16.8999 45.8502L16.4749 46.2752C15.0279 47.6597 13.1025 48.4324 11.0999 48.4324C9.0973 48.4324 7.17191 47.6597 5.72492 46.2752ZM27.3249 41.5752C28.0762 42.3439 28.4978 43.3754 28.4999 44.4502C28.5004 45.5256 28.0785 46.5581 27.3249 47.3252C26.5434 48.0509 25.5164 48.4543 24.4499 48.4543C23.3834 48.4543 22.3564 48.0509 21.5749 47.3252L20.2749 46.0002L25.9999 40.3252L27.3249 41.5752ZM30.3499 36.0002C29.2061 35.9853 28.0708 36.1988 27.0105 36.628C25.9502 37.0573 24.9862 37.6938 24.1749 38.5002L19.2749 43.5002H18.4999C15.8478 43.5002 13.3042 42.4467 11.4289 40.5713C9.55349 38.6959 8.49992 36.1524 8.49992 33.5002C8.48656 33.2421 8.48656 32.9834 8.49992 32.7252L13.4999 27.7252C14.3019 26.9107 14.9354 25.946 15.3644 24.8865C15.7933 23.827 16.0093 22.6933 15.9999 21.5502V12.8752C16.6499 14.0502 17.3499 15.1752 18.0249 16.1502C18.9999 17.6002 19.9999 18.9252 21.0249 20.1752C22.6322 22.1557 24.3429 24.05 26.1499 25.8502C27.9749 27.6752 29.8749 29.4002 31.7999 30.9752C33.0749 32.0002 34.2999 32.9752 35.8499 33.9752C36.8249 34.6502 37.9499 35.3502 39.1249 36.0002H30.3499Z"
              fill="green"
            />
          </svg>

          <h3>Reach more fans</h3>
          <p>
            Easily re-purpose your video content and cross-post on social channels to grow and increase your engagement. 
          </p>

        </div>
        <div className="cerebriam-content animate__animated animate__zoomIn">
          <svg
            width="50"
            height="60"
            viewBox="0 0 50 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M36.7892 43.4765L43.1876 37.4062C43.6564 36.9609 43.6798 36.2343 43.2345 35.7656C42.7892 35.2968 42.0626 35.2734 41.5939 35.7187L36.0157 40.9921L33.7423 38.625C33.297 38.1562 32.5704 38.1562 32.1017 38.6015C31.6329 39.0468 31.6329 39.7734 32.0782 40.2421L35.1486 43.4296C35.3829 43.664 35.6876 43.7812 35.9923 43.7812C36.2736 43.7812 36.5548 43.6875 36.7892 43.4765Z"
              fill="#01C67F"
            />
            <path
              d="M49.211 37.3827C49.1173 36.8202 49.0235 36.4217 48.9063 36.1405C47.2891 31.3593 42.8594 28.1249 37.7735 28.1014H37.4219C32.4063 28.1483 27.9766 31.3827 26.3829 36.1405C26.2657 36.4452 26.1719 36.8436 26.0782 37.4061C25.7266 39.4218 25.961 41.4374 26.7344 43.2186C26.7344 43.2421 26.7579 43.2889 26.7813 43.3124C26.8047 43.3592 26.8047 43.3827 26.8282 43.4296C27.4376 44.7421 28.3047 46.2655 29.1485 47.7421C29.6641 48.6327 30.1797 49.5233 30.6251 50.3671C30.9297 50.9296 31.6329 51.1405 32.1954 50.8358C32.7579 50.5311 32.9688 49.828 32.6641 49.2655C32.1954 48.3983 31.6797 47.4842 31.1407 46.5702C30.3438 45.1639 29.5001 43.7108 28.9376 42.4921C28.9141 42.4452 28.8907 42.3983 28.8672 42.328C28.2579 40.9217 28.0938 39.3514 28.3516 37.8046C28.3751 37.6405 28.4688 37.1718 28.5626 36.8671C29.8516 33.0233 33.4141 30.4452 37.4923 30.3983H37.8204C41.8282 30.4218 45.3907 33.0233 46.7032 36.8905C46.7969 37.1717 46.8907 37.6405 46.9141 37.7811C47.1954 39.3514 47.0079 40.8983 46.3985 42.3514C46.3751 42.3983 46.3516 42.4452 46.3516 42.4921C45.7891 43.7108 44.9454 45.1639 44.1485 46.5702C43.6094 47.4842 43.0938 48.3983 42.6251 49.2655C42.3204 49.828 42.5313 50.5311 43.0938 50.8358C43.2579 50.9296 43.4454 50.9764 43.6329 50.9764C44.0548 50.9764 44.4532 50.7421 44.6641 50.3671C45.1094 49.5233 45.6251 48.6327 46.1407 47.7421C46.9844 46.2655 47.8516 44.7655 48.461 43.4296C48.461 43.4061 48.4844 43.3592 48.5079 43.3358L48.5548 43.2421C49.3516 41.4374 49.5626 39.3983 49.211 37.3827Z"
              fill="#01C67F"
            />
            <path
              d="M41.9921 52.289H33.2968C32.8281 52.289 32.4062 52.4999 32.1015 52.8515C31.7968 53.2031 31.6796 53.6718 31.7734 54.1171L32.1953 56.3203C32.3359 57.0468 32.9687 57.5859 33.7187 57.5859H34.1171C34.9843 58.6406 36.2734 59.2734 37.6562 59.2734C39.039 59.2734 40.3281 58.6406 41.1953 57.5859H41.5937C42.3437 57.5859 42.9765 57.0468 43.1171 56.3203L43.539 54.1171C43.6328 53.6718 43.5156 53.2031 43.2109 52.8515C42.8828 52.4999 42.4609 52.289 41.9921 52.289ZM40.9374 55.2656H40.5859C40.164 55.2656 39.789 55.4765 39.5781 55.8281C39.1796 56.5077 38.4296 56.9296 37.6328 56.9296C36.8359 56.9296 36.0859 56.5077 35.6874 55.8281C35.4765 55.4765 35.1015 55.2656 34.6796 55.2656H34.3749L34.2578 54.6093H41.0781L40.9374 55.2656Z"
              fill="#01C67F"
            />
            <path
              d="M12.2265 14.5078C16.0234 14.5078 19.1171 11.414 19.1171 7.61713C19.1171 3.82025 16.0234 0.726501 12.2265 0.726501C8.42961 0.726501 5.33586 3.82025 5.33586 7.61713C5.33586 11.414 8.42961 14.5078 12.2265 14.5078ZM12.2265 3.04681C14.7343 3.04681 16.7968 5.10931 16.7968 7.61713C16.7968 10.1249 14.7343 12.1874 12.2265 12.1874C9.71867 12.1874 7.65617 10.1249 7.65617 7.61713C7.65617 5.10931 9.71867 3.04681 12.2265 3.04681Z"
              fill="#01C67F"
            />
            <path
              d="M20.5469 23.9531C19.9141 23.9062 19.3516 24.3984 19.3047 25.0312L18.25 40.5468C18.25 40.5937 18.2266 40.6406 18.2266 40.664L17.2422 55.7578C17.1953 56.414 16.6328 56.9531 15.9766 56.9531H8.47656C7.79687 56.9531 7.25781 56.4375 7.21094 55.7578L6.22656 40.664C6.20312 40.1953 5.875 39.7734 5.40625 39.6328C3.95313 39.1875 3.95312 39.1875 3.85937 37.6172L2.96875 21.6093V21.4453C4.28125 21.0468 6.57812 20.3203 7.67969 19.9687L11.4531 23.4843C11.8984 23.9062 12.6016 23.9062 13.0469 23.4843L16.8437 19.9218L27.9766 22.4297C28.1406 22.4765 28.3047 22.4765 28.4687 22.4297L38.9219 20.2968C39.5547 20.1797 39.9531 19.5468 39.8359 18.9375C39.7188 18.3281 39.0859 17.9062 38.4766 18.0234L28.2578 20.1093L16.7734 17.5078C16.3984 17.414 16 17.5312 15.7187 17.789L12.2266 21.0468L8.75781 17.789C8.45312 17.5078 8.00781 17.414 7.60937 17.5312C7.60937 17.5312 4.07031 18.6562 2.26562 19.1953C1.21094 19.5234 0.625 20.3203 0.625 21.3984C0.625 21.4922 0.625 21.6797 0.625 21.6797L1.51562 37.4765L1.53906 37.7343C1.70312 40.125 2.10156 40.875 3.95312 41.5547L4.89062 55.875C5.00781 57.75 6.57812 59.2265 8.47656 59.2265H15.9766C17.8516 59.2265 19.4219 57.75 19.5625 55.875L20.5469 40.8984C20.5469 40.8515 20.5469 40.8281 20.5703 40.7812L21.6484 25.1484C21.6719 24.539 21.2031 23.9765 20.5469 23.9531Z"
              fill="#01C67F"
            />
          </svg>
          <h3>Focus on the creative</h3>
          <p>
            Cut your editing time in half. Spend more time producing creative content or simply take a break with all of your spare time ;-)
          </p>
        </div>
        <div className="cerebriam-content animate__animated animate__zoomIn">
          <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M46.25 5.15H42.5V3.75C42.5 2.75544 42.1049 1.80161 41.4016 1.09835C40.6984 0.395088 39.7446 0 38.75 0H11.25C10.2554 0 9.30161 0.395088 8.59835 1.09835C7.89509 1.80161 7.5 2.75544 7.5 3.75V5.15H3.75C2.75544 5.15 1.80161 5.54509 1.09835 6.24835C0.395088 6.95161 0 7.90544 0 8.9V13.9C0 22.025 8.95 32.025 20 34.475V40.3L10.95 42.5C10.6749 42.5725 10.4319 42.7349 10.2598 42.9614C10.0876 43.1879 9.99619 43.4655 10 43.75V48.75C10 49.0815 10.1317 49.3995 10.3661 49.6339C10.6005 49.8683 10.9185 50 11.25 50H38.75C39.0815 50 39.3995 49.8683 39.6339 49.6339C39.8683 49.3995 40 49.0815 40 48.75V43.75C40.0014 43.4718 39.9081 43.2015 39.7355 42.9834C39.5628 42.7653 39.3211 42.6124 39.05 42.55L30 40.275V34.45C41.05 31.95 50 21.95 50 13.875V8.875C49.9934 7.88478 49.5954 6.93736 48.8929 6.2395C48.1903 5.54163 47.2402 5.14998 46.25 5.15ZM10 3.75C10 3.41848 10.1317 3.10054 10.3661 2.86612C10.6005 2.6317 10.9185 2.5 11.25 2.5H38.75C39.0815 2.5 39.3995 2.6317 39.6339 2.86612C39.8683 3.10054 40 3.41848 40 3.75V10.125C40 18.95 33.275 32.625 25 32.625C16.725 32.625 10 18.95 10 10.125V3.75ZM2.5 13.875V8.875C2.5 8.54348 2.6317 8.22554 2.86612 7.99112C3.10054 7.7567 3.41848 7.625 3.75 7.625H7.5V10.125C7.74022 17.6284 10.617 24.8072 15.625 30.4C7.75 26.8 2.5 19.275 2.5 13.875ZM37.5 47.5H12.5V44.725L21.4 42.5H28.6L37.5 44.725V47.5ZM27.5 40H22.5V34.85C24.1607 35.0501 25.8393 35.0501 27.5 34.85V40ZM47.5 13.875C47.5 19.275 42.25 26.8 34.375 30.4C39.383 24.8072 42.2598 17.6284 42.5 10.125V7.625H46.25C46.5815 7.625 46.8995 7.7567 47.1339 7.99112C47.3683 8.22554 47.5 8.54348 47.5 8.875V13.875Z"
              fill="#FF9292"
            />
            <path
              d="M21.25 20C21.5815 20 21.8995 19.8683 22.1339 19.6339C22.3683 19.3995 22.5 19.0815 22.5 18.75V11.25C22.5 10.9185 22.3683 10.6005 22.1339 10.3661C21.8995 10.1317 21.5815 10 21.25 10C20.9185 10 20.6005 10.1317 20.3661 10.3661C20.1317 10.6005 20 10.9185 20 11.25V18.75C20 19.0815 20.1317 19.3995 20.3661 19.6339C20.6005 19.8683 20.9185 20 21.25 20Z"
              fill="#FF9292"
            />
            <path
              d="M28.75 20C29.0815 20 29.3995 19.8683 29.6339 19.6339C29.8683 19.3995 30 19.0815 30 18.75V11.25C30 10.9185 29.8683 10.6005 29.6339 10.3661C29.3995 10.1317 29.0815 10 28.75 10C28.4185 10 28.1005 10.1317 27.8661 10.3661C27.6317 10.6005 27.5 10.9185 27.5 11.25V18.75C27.5 19.0815 27.6317 19.3995 27.8661 19.6339C28.1005 19.8683 28.4185 20 28.75 20Z"
              fill="#FF9292"
            />
          </svg>

          <h3>Patent pending AI tech</h3>
          <p>
            Use artificial intelligence to make a tonne of authentic videos and ensure that the main focus in your videos is always on screen.
          </p>
        </div>
      </div>

      <div className="cerebriam-row walkthrough">
        <div className="cerebriam-col-6 image">
          <div className="cerebriam-content animate__animated animate__fadeIn">
            <img className="desktop" src={MultipleRatios} alt="multiple" />
            <img className="mobile" src={MultipleRatiosMobile} alt="multiple" />
          </div>
        </div>
        <div className="cerebriam-col-6 content">
          <div className="cerebriam-content">
            <h2>
              Compose and create multiple aspect ratio videos
            </h2>
            <p>
            Content creators best kept secret is no more. Now you too, can use Cerebriam Studio to make up to 4 aspect ratio videos simultaneously - saving 50% of your time.  
              
            </p>
            <button  onClick={() => setIsSignUpOpen(true)}>
              START FREE TRIAL
            </button>
          </div>
        </div>
      </div>

      <div className="cerebriam-row walkthrough">
        <div className="cerebriam-col-6 content second">
          <div className="cerebriam-content">
            <h2>One editor to rule them all </h2>
            <p>
              Be in control with a powerful, patent pending, editor which automatically applies all the video,
              photo, sound, and text edits made to one aspect ratio to all the
              other aspect ratios.
            </p>
            <button onClick={() => setIsSignUpOpen(true)}>
              START FREE TRIAL
            </button>
          </div>
        </div>
        <div className="cerebriam-col-6 image">
          <div className="cerebriam-content animate__animated animate__fadeIn">
            <img className="desktop" src={OneRatio} alt="multiple" />
            <img className="mobile" src={OneRatioMobile} alt="multiple" />
          </div>
        </div>
      </div>

      <div className="cerebriam-row cerebriam-tracking">
        <div className="cerebriam-col-6 images">
          <div className="cerebriam-card">
            <div className="cerebriam-image animate__animated animate__fadeIn">
              <h3>With AI Tracking</h3>
              <img src={WithAI} alt="with-ai" />
            </div>
            <div className="cerebriam-image animate__animated animate__fadeIn">
              <h3>Without AI Tracking</h3>
              <img src={WithoutAI} alt="without-ai" />
            </div>
          </div>
        </div>
        <div className="cerebriam-col-6 content">
          <div className="cerebriam-content">
            <h2>
            Be free to move, to dance, to create
            </h2>
            <p>
            Exclusively designed for creators, our intelligent AI algorithms ensure that 
            regardless of your movements in the video, you will always be in the centre of the frame - thanks to the automatic tracking.

            </p>
            <button onClick={() => setIsSignUpOpen(true)}>
              START FREE TRIAL
            </button>
          </div>
        </div>
      </div>

      <div className="cerebriam-row partnership">
        <div className="cerebriam-col-6 texts">
          <div className="cerebriam-content">
            <h2>PARTNERSHIPS</h2>
            <h3>We love creative talent</h3> 
           
            <p>
            Some of the best social talent uses Cerebriam Studio 
            to make their video content more dynamic and more exciting! Why not join the community?!
            </p>

            {/* <div className="cerebriam-row partners-logos">
              <img className="img-1" src={Netflix} alt="netflix" />
              <img className="img-2" src={Drawkit} alt="drawkit" />
            </div>
            <div className="cerebriam-row partners-logos">
              <img className="img-1" src={Figma} alt="figma" />
              <img className="img-2" src={Stripe} alt="stripe" />
            </div> */}
          </div>
        </div>
        <div className="cerebriam-col-6 bg-img">
          <div className="cerebriam-content"></div>
        </div>
      </div>

      <div className="dark-bg">
        <div className="cerebriam-content">
          <h2>
            Made by creators for creators. With more AI based automation to come...
          </h2>
          <p>
            Putting the art of good video entertainment first, and backed by the latest technological developments, Cerebriam Studio will always be your secret tool to keep ahead of the game.
            {' '}
          </p>
          <button onClick={() => setIsSignUpOpen(true)}>
            TRY FOR FREE{' '}
          </button>
        </div>
      </div>

      <div className="testimonial">
        <img
          className="testimonial-bg-img left"
          src={TestimonialLeft}
          alt="testimonial-left"
        />
        <img
          className="testimonial-bg-img right"
          src={TestimonialRight}
          alt="testimonial-right"
        />
        <div className="cerebriam-content">
          <h2>TESTIMONIALS</h2>
          <h3>Our clients are a great bunch</h3>
          <p>{testimonials[activeTestimonial]?.message}</p>
          <div className="photos animate__animated animate__fadeInUp">
            <div
              className={`photo${activeTestimonial === 0 ? ' active' : ''}`}
              onClick={() => changeTestimonial(0)}>
              <img src={PersonOne} alt="person" />
            </div>
            <div
              className={`photo${activeTestimonial === 1 ? ' active' : ''}`}
              onClick={() => changeTestimonial(1)}>
              <img src={PersonTwo} alt="person" />
            </div>
            <div
              className={`photo${activeTestimonial === 2 ? ' active' : ''}`}
              onClick={() => changeTestimonial(2)}>
              <img src={PersonThree} alt="person" />
            </div>
            {/* <div
              className={`photo${activeTestimonial === 3 ? ' active' : ''}`}
              onClick={() => changeTestimonial(3)}>
              <img src={PersonOne} alt="person" />
            </div> */}
            {/* <div
              className={`photo${activeTestimonial === 4 ? ' active' : ''}`}
              onClick={() => changeTestimonial(4)}>
              <img src={PersonOne} alt="person" />
            </div> */}
          </div>
          <p className="author-name">
            {testimonials[activeTestimonial]?.author}
          </p>
        </div>
      </div>
    </section>
  )
}

export default Services
